
import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';
import { SanityImageSource } from '@sanity/image-url/lib/types/types';

// Sanity configuration
export const sanityConfig = {
  projectId: 'njfjtcje', // Your Sanity project ID
  dataset: 'production',
  apiVersion: '2023-09-26', // Use the current date in YYYY-MM-DD format
  useCdn: true, // Set to false if you want to ensure fresh content
  token: import.meta.env.VITE_SANITY_TOKEN // Your Sanity API token
};

// Create a client
export const sanityClient = createClient(sanityConfig);

// Set up image URL builder
const builder = imageUrlBuilder(sanityClient);

/**
 * Helper function to generate image URLs from Sanity image references
 */
export function urlFor(source: SanityImageSource) {
  return builder.image(source);
}

/**
 * Fetch all blog posts with pagination
 */
export async function getAllPosts(limit = 10, offset = 0) {
  return sanityClient.fetch(
    `*[_type == "post"] | order(publishedAt desc) [${offset}...${offset + limit}] {
      _id,
      title,
      slug,
      excerpt,
      mainImage,
      publishedAt,
      author,
      category,
      tags
    }`
  );
}

/**
 * Fetch a single blog post by slug
 */
export async function getPostBySlug(slug: string) {
  return sanityClient.fetch(
    `*[_type == "post" && slug.current == $slug][0] {
      _id,
      title,
      slug,
      body,
      mainImage,
      publishedAt,
      author,
      category,
      tags
    }`,
    { slug }
  );
}

/**
 * Fetch posts by category
 */
export async function getPostsByCategory(category: string, limit = 10, offset = 0) {
  return sanityClient.fetch(
    `*[_type == "post" && category == $category] | order(publishedAt desc) [${offset}...${offset + limit}] {
      _id,
      title,
      slug,
      excerpt,
      mainImage,
      publishedAt,
      author,
      category,
      tags
    }`,
    { category }
  );
}

/**
 * Fetch posts by tag
 */
export async function getPostsByTag(tag: string, limit = 10, offset = 0) {
  // Fix: Using the tag parameter correctly
  const params = { tag } as any;
  
  return sanityClient.fetch(
    `*[_type == "post" && $tag in tags] | order(publishedAt desc) [${offset}...${offset + limit}] {
      _id,
      title,
      slug,
      excerpt,
      mainImage,
      publishedAt,
      author,
      category,
      tags
    }`,
    params
  );
}
